<template lang="pug">
div
  .h2#total-hub-documents.color-gray.text-center.mt-5(v-html="totalDocumentsText" v-if="!loading")
  .h2.d-flex.justify-content-center.mt-5(v-else)
    .py-3.box_hub.w-50
  .px-xl-5
    .row#recent_hubs.mostRecent.p-3(v-if="mustShowRecentHubs")
      h4.col-12.color-primary.px-3.mb-0
        i.fas.fa-history.pr-2
        span {{t("components.forms.hubs.recents")}}
      .hubsFilter_recent.col-6.col-md-4.col-xl-2.py-3.px-2(v-for="recent in recentHubs" :key="recent.name")
        hub-card-vue(:hub="recent")
  .row.px-xl-3.justify-content-center(v-if="!loading")
    .hubsFilter__element.col-6.col-md-4.col-lg-3.col-xl-2.py-3.px-2(v-for="hub in filteredHubs" :key="hub.id")
      hub-card-vue(:hub="hub")
  .row.px-xl-5(v-else)
    .col-6.col-md-4.col-xl-2.py-3.px-2(v-for="hub in 12")
      .box_hub.hubsFilterBoxHub
</template>
<script>

import mixins from "common/mixins.js"
import { mapState, mapGetters, mapActions } from "vuex"

export default {
  name: "hubs-gallery-vue",
  components: {
    "hub-card-vue": () =>
      import(/* webpackChunkName: "[request]" */ "components/hubs/Card"),
  },
  props: {
    recentHubIdsList: { type: Array, default: () => [] }
  },
  mixins: [mixins.translate],
  methods: {
    ...mapActions("hub_search", ["retrieveRecentHubs"])
  },
  computed: {
    totalDocumentsText() {
      if (this.filteredHubs.length == this.hubs.length)
        return I18n.t("components.forms.hubs.total_documents", {
          total: this.totalDocuments,
        });
      return I18n.t("components.forms.hubs.total_selection", {
        total: this.totalDocuments,
      });
    },
    mustShowRecentHubs() {
      return this.showRecentHubs && !this.fromTemas
    },
    ...mapGetters("hub_search", ["showRecentHubs"]),
    ...mapState(
      "hub_search",
      ["filteredHubs", "hubs", "recentHubs", "totalDocuments", "loading", "fromTemas"]
    ),
  },
  mounted() {
    this.retrieveRecentHubs(this.recentHubIdsList)
  }
};
</script>
